import i18next from 'i18next';

/**
 * Formats a date with timestamp for "last updated" displays
 * @param date - Date object to format
 * @param language - i18n language code
 * @returns Formatted date string (e.g., "03/03/26, 01:35:30 PM")
 */
export const formatLastUpdated = (date: Date, language: string): string => {
  return new Intl.DateTimeFormat(language, {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(date);
};

/**
 * Formats a date for display in tables (date only, no time)
 * @param date - Date object, string, or null
 * @param language - i18n language code
 * @returns Formatted date string (e.g., "03/03/2026") or null if input is null
 */
export const formatDate = (
  date: Date | string | null,
  language: string,
): string | null => {
  if (!date) return null;

  const dateObj = date instanceof Date ? date : new Date(date);

  return new Intl.DateTimeFormat(language, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(dateObj);
};

export const formatTime = (date: Date) => {
  const now = new Date();
  const diffInDays = Math.floor(
    (now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (diffInDays === 0) {
    return i18next.t('notes.today');
  } else if (diffInDays === 1) {
    return i18next.t('notes.yesterday');
  } else {
    return i18next.t('notes.daysAgo', { count: diffInDays });
  }
};
